import { render, staticRenderFns } from "./yindao.vue?vue&type=template&id=29e2a490&scoped=true"
import script from "./yindao.vue?vue&type=script&lang=js"
export * from "./yindao.vue?vue&type=script&lang=js"
import style0 from "./yindao.vue?vue&type=style&index=0&id=29e2a490&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e2a490",
  null
  
)

export default component.exports